function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useEffect, useState } from "react";
import cx from "classnames";
var AutoSlimNav = function AutoSlimNav(props) {
  var nav = props.nav,
    selesMode = props.selesMode,
    active = props.active;
  return /*#__PURE__*/React.createElement("nav", {
    id: 'tcTopNav',
    className: 'tc-top-nav'
  }, props.children, /*#__PURE__*/React.createElement("div", {
    id: 'tcTopNavContent',
    className: 'tc-top-nav-content'
  }, nav.usedCarAuto && !selesMode && nav.usedCarAuto({
    active: active
  })), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-right'
  }, !selesMode && nav.helpSell(), nav.user(), nav.help(), nav.app()));
};
var AutoIndexSlimNav = function AutoIndexSlimNav(props) {
  var nav = props.nav,
    selesMode = props.selesMode;
  return /*#__PURE__*/React.createElement("nav", {
    id: 'tcTopNav',
    className: 'tc-top-nav'
  }, props.children, /*#__PURE__*/React.createElement("div", {
    id: 'tcTopNavContent',
    className: 'tc-top-nav-content'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-right'
  }, !selesMode && nav.helpSell(), nav.user(), nav.help(), nav.app()));
};
var DefaultSlimNav = function DefaultSlimNav(props) {
  var nav = props.nav,
    selesMode = props.selesMode,
    active = props.active;
  return /*#__PURE__*/React.createElement("nav", {
    id: 'tcTopNav',
    className: 'tc-top-nav'
  }, props.children, /*#__PURE__*/React.createElement("div", {
    id: 'tcTopNavContent',
    className: 'tc-top-nav-content'
  }, !selesMode && nav.usedCar({
    active: active
  }), !selesMode && nav.personalSell({
    active: active
  }), !selesMode && nav.valuation && nav.valuation({
    active: active
  }), !selesMode && nav.newCar({
    active: active
  }), !selesMode && nav.buyCar({
    active: active
  }), !selesMode && nav.evPages({
    active: active
  })), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-right'
  }, !selesMode && nav.helpSell(), !selesMode && nav.search(), nav.user(), nav.help(), nav.app()));
};
var Nav = function Nav(_a) {
  var nav = _a.nav,
    _a$selesMode = _a.selesMode,
    selesMode = _a$selesMode === void 0 ? false : _a$selesMode,
    props = __rest(_a, ["nav", "selesMode"]);
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isShowBoxShadow = _useState4[0],
    setIsShowBoxShadow = _useState4[1];
  function activeNav() {
    var pathname = location.pathname;
    if (/^c\.(.*)8891\.com\.tw$/.test(location.hostname)) {
      if (/^\/buyCar/.test(pathname)) {
        setActive(3);
      } else if (/^\/Models/.test(pathname)) {
        setActive(0);
      } else if (/^\/HDPhoto/.test(pathname)) {
        setActive(6);
      } else if (/\/photoMovie-index\.html/.test(pathname)) {
        setActive(4);
      } else if (/^\/photoModel-(ratingCompare|compare).html/.test(pathname)) {
        setActive(5);
      } else if (/^\/(Guide|news|Articles|trialrun)/.test(pathname)) {
        var isAticle = document.getElementsByClassName("indexArticleArticleLeft");
        if (isAticle.length === 0) {
          setActive(2);
        }
      } else if (/^\/collection\/(details|list)/.test(pathname)) {
        setActive(7);
      }
    }
  }
  useEffect(function () {
    activeNav();
    setIsShowBoxShadow(/buyCar|Article|Models|photoMovie|photoModel|collection/.test(location.pathname));
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(_defineProperty({}, "nav-box-shadow", isShowBoxShadow)),
    id: 'package-business-nav'
  }, props.type === "default" && (/*#__PURE__*/React.createElement(DefaultSlimNav, {
    nav: nav,
    selesMode: selesMode,
    active: active
  }, props.children)), props.type === "slim" && (/*#__PURE__*/React.createElement(DefaultSlimNav, {
    nav: nav,
    selesMode: selesMode,
    active: active
  }, props.children)), props.type === "autoIndexSlim" && (/*#__PURE__*/React.createElement(AutoIndexSlimNav, {
    nav: nav,
    selesMode: selesMode,
    active: active
  }, props.children)), props.type === "autoSlim" && (/*#__PURE__*/React.createElement(AutoSlimNav, {
    nav: nav,
    selesMode: selesMode,
    active: active
  }, props.children)), props.type === "imIndexSlim" && (/*#__PURE__*/React.createElement(DefaultSlimNav, {
    nav: nav,
    selesMode: selesMode,
    active: active
  }, props.children)));
};
export default Nav;